import * as React from "react";
import { useRouter } from "next/router";
import { useMachine } from "@xstate/react";
import { portalRoutes } from "@nju/routes";
import { Panel } from "@nju/ui";
import { changeConsentsMachine } from "./changeConsents.machine";
import { ChangeConsentsError } from "./partials/ChangeConsentsError";
import { ChangeConsentsForm } from "./partials/ChangeConsentsForm";

export function DashboardUserProfileChangeConsents() {
  const [wasError, setWasError] = React.useState(false);
  const router = useRouter();
  const [current, send] = useMachine(changeConsentsMachine, {
    context: {
      consentsCatalogue: [],
    },
  });
  const { context, matches } = current;
  const isUpdateSuccess = matches("updateConsentsSuccess");

  React.useEffect(() => {
    if (matches("updateConsentsError")) {
      setWasError(true);
    }
    if (matches("updateConsentsSuccess") || matches("init")) {
      setWasError(false);
    }
  }, [matches]);

  React.useEffect(() => {
    if (isUpdateSuccess) {
      router.replace(portalRoutes.mojeKonto.mojProfil.index.get());
    }
  }, [router, isUpdateSuccess]);

  const selectConsent = React.useCallback(
    ({
      value,
      consentId,
      consentVersion,
    }: {
      value: string;
      consentId: string;
      consentVersion: number;
    }) => {
      send({
        type: "SELECT_CONSENT",
        consent: {
          consentId,
          consentVersion,
          accepted: value === "yes" ? true : false,
        },
      });
    },
    [send],
  );

  const handleSubmit = React.useCallback(() => {
    send({ type: "SUBMIT" });
  }, [send]);

  if (matches("updateConsentsError") || wasError) {
    return (
      <ChangeConsentsError
        isSubmitting={matches("saving")}
        onRetry={handleSubmit}
      />
    );
  }

  return (
    <Panel>
      <ChangeConsentsForm
        context={context}
        handleSubmit={handleSubmit}
        isSaving={matches("saving")}
        selectConsent={selectConsent}
      />
    </Panel>
  );
}
